import {
	COMPONENT_STATE_INIT_INSTANCE,
	COMPONENT_STATE_UPDATE_INSTANCE,
	COMPONENT_STATE_CLEAR_INSTANCE,
	COMPONENT_STATE_RESET_COMPONENT
} from "./actionTypes";

/**
 * Initialize a component instance in componentState.
 *
 * @param {string} componentKey - Logical key for a feature (e.g. "newVideoPlayer")
 * @param {string} instanceId   - Unique id for this instance (e.g. passed from parent)
 * @param {object} initialState - Initial state for this instance
 */
export const initComponentInstance = (componentKey, instanceId, initialState = {}) => ({
	type: COMPONENT_STATE_INIT_INSTANCE,
	payload: { componentKey, instanceId, initialState }
});

const isPlainObject = value => {
	return value !== null && typeof value === "object" && !Array.isArray(value);
};

const deepMerge = (target = {}, source = {}) => {
	const output = { ...target };

	Object.keys(source).forEach(key => {
		const targetValue = target[key];
		const sourceValue = source[key];

		if (isPlainObject(targetValue) && isPlainObject(sourceValue)) {
			output[key] = deepMerge(targetValue, sourceValue);
		} else {
			output[key] = sourceValue;
		}
	});

	return output;
};

export const updateComponentInstance = (componentKey, instanceId, changes) => (dispatch, getState) => {
	const state = getState();
	const existingInstance = state.componentState?.[componentKey]?.[instanceId] || {};

	const mergedChanges = deepMerge(existingInstance, changes);

	dispatch({
		type: COMPONENT_STATE_UPDATE_INSTANCE,
		payload: {
			componentKey,
			instanceId,
			changes: mergedChanges
		}
	});
};
/**
 * Remove a single instance from componentState.
 */
export const clearComponentInstance = (componentKey, instanceId) => ({
	type: COMPONENT_STATE_CLEAR_INSTANCE,
	payload: { componentKey, instanceId }
});

/**
 * Remove *all* instances for a given componentKey.
 * Example: clear every NewVideoPlayer instance.
 */
export const resetComponentKey = componentKey => ({
	type: COMPONENT_STATE_RESET_COMPONENT,
	payload: { componentKey }
});
